export enum SearchableTypeEnum {
  Auction = 'auction',
  PublicProfile = 'public-profile'
}
